export const setReadOnly = (state, readOnly = false) => {
  return { readOnly };
};
